import { render } from "./projectItem.vue?vue&type=template&id=3394b0e2"
import script from "./projectItem.vue?vue&type=script&lang=js"
export * from "./projectItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__